import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { Header } from "../components/Header";
import { Hero } from "../components/Hero";
import { Marquee } from "../components/Marquee";
import { Services } from "../components/Services";
import { Work } from "../components/Work";
import { Approach } from "../components/Approach";
import { Houses } from "../components/Houses";
import { Journal } from "../components/Journal";
import { Contact } from "../components/Contact";
import { Footer } from "../components/Footer";
import { SmoothScroll, scrollToId } from "../components/SmoothScroll";
import { Seo } from "../components/Seo";
import { useLang } from "../i18n/LangContext";

export default function Home() {
  const { hash } = useLocation();
  const { t } = useLang();

  useEffect(() => {
    if (!hash) return;
    const id = hash.slice(1);
    const timer = setTimeout(() => scrollToId(id), 250);
    return () => clearTimeout(timer);
  }, [hash]);

  return (
    <div className="grain" data-testid="home-page">
      <Seo title={t.seo.homeTitle} description={t.seo.homeDescription} />
      <SmoothScroll />
      <Header />
      <main>
        <Hero />
        <Marquee />
        <Services />
        <Work />
        <Approach />
        <Houses />
        <Journal />
        <Contact />
      </main>
      <Footer />
    </div>
  );
}
